import { Injectable } from '@angular/core';
// import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator/ngx';
import { StartNavigation } from '@proteansoftware/capacitor-start-navigation';
import { Platform } from '@ionic/angular';

import type { TCoordinate, TDistinctColorInfo } from '@shared/models';
import { Constants } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class MapHelperService {
    private onDevice!: boolean;
    private navigationApp: any;

    // , private launchNavigator: LaunchNavigator
    constructor(private platform: Platform) {
    }

    public init() {
        this.onDevice = this.platform.is('mobileweb') || this.platform.is('mobile');
    }

    public runningOnDevice(): boolean {
        return this.onDevice;
    }

    // private chooseNavigationApp(): Promise<{}> {
    //     let app;
    //     const defaultApp = this.launchNavigator.APP.GOOGLE_MAPS;

    //     const promise = new Promise(async (resolve, reject) => {
    //         const isAvailable = await this.launchNavigator.isAppAvailable(defaultApp); // , (isAvailable) => {
    //         if (isAvailable) {
    //             app = this.launchNavigator.APP.GOOGLE_MAPS;
    //             resolve(app);
    //         } else {
    //             console.warn('Google Maps not available - falling back to user selection');
    //             app = this.launchNavigator.APP.USER_SELECT;
    //             resolve(app);
    //         }
    //     });
    //     return promise;
    // }

    // public launchNavigationApp_Original(tocoordinate, onSuccessCallback, onErrorCallback): void {
    //     if (!this.onDevice) {
    //         onErrorCallback('Navigation will only work on a real device.');
    //     } else {
    //         const destination = [];
    //         destination[0] = tocoordinate.latitude;
    //         destination[1] = tocoordinate.longitude;

    //         const options: LaunchNavigatorOptions = {
    //             'app': this.navigationApp,
    //             successCallback: onSuccessCallback,
    //             errorCallback: onErrorCallback
    //         };

    //         this.launchNavigator.navigate(destination, options);
    //     }
    // }

    public async launchNavigationApp(toCoordinate: TCoordinate, coordinateName: string): Promise<void> {
        if (!this.onDevice) {
            throw new Error('Navigation will only work on a real device.');
        }

        const promise = StartNavigation.launchMapsApp({
            latitude: toCoordinate.latitude,
            longitude: toCoordinate.longitude,
            name: coordinateName
        });

        return promise;

        //     const destination = [];
        //     destination[0] = tocoordinate.latitude;
        //     destination[1] = tocoordinate.longitude;

        //     const options: LaunchNavigatorOptions = {
        //         'app': this.navigationApp,
        //         successCallback: onSuccessCallback,
        //         errorCallback: onErrorCallback
        //     };

        //     this.launchNavigator.navigate(destination, options);
        // }
    }

    // Icons can be found here: https://sites.google.com/site/gmapsdevelopment/
    // To generate these shuttle<Marker>.png files I found it easier to use Gimp 2:
    // Step 1) Find a hex color I like
    // Step 2) Use this site to convert the hex color into hsv color: https://html-color-codes.info/convert-color-format/#
    // Step 3) Use this site to replace the color: https://www.techwalla.com/articles/how-to-replace-color-in-gimp-2
    public getMarkerIcon(markerType: string): string {
        const markers = [
            { 'name': 'white', 'filename': 'shuttleWhite.png' },
            { 'name': 'red', 'filename': 'shuttleRed.png' },
            { 'name': 'blue', 'filename': 'shuttleBlue.png' },
            { 'name': 'green', 'filename': 'shuttleGreen.png' },
            { 'name': 'orange', 'filename': 'shuttleOrange.png' },
            { 'name': 'yellow', 'filename': 'shuttleYellow.png' },
            { 'name': 'black', 'filename': 'shuttleBlack.png' },

            { 'name': 'apricot', 'filename': 'shuttleApricont.png' },
            { 'name': 'brown', 'filename': 'shuttleBrown.png' },
            { 'name': 'cyan', 'filename': 'shuttleCyan.png' },
            { 'name': 'lavender', 'filename': 'shuttleLavender.png' },
            { 'name': 'lightblue', 'filename': 'shuttleLightBlue.png' },
            { 'name': 'lime', 'filename': 'shuttleLime.png' },
            { 'name': 'magenta', 'filename': 'shuttleMagenta.png' },
            { 'name': 'mint', 'filename': 'shuttleMint.png' },
            { 'name': 'olive', 'filename': 'shuttleOlive.png' },
            { 'name': 'pink', 'filename': 'shuttlePink.png' },
            { 'name': 'purple', 'filename': 'shuttlePurple.png' },
            { 'name': 'silver', 'filename': 'shuttleSilver.png' },
            { 'name': 'teal', 'filename': 'shuttleTeal.png' },
            { 'name': 'dealership', 'filename': 'dealershipMarker.png' },
            { 'name': 'mylocation', 'filename': 'triangleKnow.png' },
            { 'name': 'endne', 'filename': 'endNE.png' },
            { 'name': 'endnw', 'filename': 'endNW.png' },
            { 'name': 'startns', 'filename': 'startNS.png' },
            { 'name': 'startnw', 'filename': 'startNW.png' },
            { 'name': 'transparent', 'filename': 'transparent.png' }
        ];

        if (!markerType) {
            throw new Error('Invalid markerType argument.');
        }

        const markerName = markerType.toLowerCase();
        const marker = markers.find((m) => m.name === markerName);
        if (!marker) {
            throw new Error('Invalid markerType.');
        }
        const icon = 'assets/images/' + marker.filename;

        return icon;
    }

    // public assignLetterDesignatorToSelectedTickets(tickets) {
    //     let letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    //     for (let idx = 0; idx < tickets.length; idx++) {
    //         let ticket = tickets[idx];
    //         let letter = letters[idx % letters.length];
    //         ticket.letter = letter;
    //     }
    // }
}
